/* eslint-disable */

<template>
  <div>
    <div class="vx-row">
      <!-- Left: switcher + task checklist -->
      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="selectedRouter === 'r1' ? 'primary' : 'grey'" type="filled" class="flex-1" @click="selectedRouter = 'r1'"
            >R1</vs-button
          >
          <vs-button
            :color="selectedRouter === 'r3' ? 'primary' : 'grey'"
            :disabled="!r3Unlocked"
            type="filled"
            class="flex-1"
            @click="selectedRouter = 'r3'"
            >R3</vs-button
          >
        </div>

        <vx-card style="overflow-y: auto">
          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (task1Done ? '#28C76F' : '#3a3f51') }">
            <div
              class="flex items-center gap-2 px-3 py-2"
              :style="{ background: task1Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }"
            >
              <span
                class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white"
                :style="{ width: '20px', height: '20px', fontSize: '10px', background: task1Done ? '#28C76F' : '#4a5568' }"
                >1</span
              >
              <span class="font-semibold text-sm flex-1">R1 Primary Route to PC1 via R2</span>
              <span class="text-xs font-medium" :class="task1Done ? 'text-success' : 'text-grey'">{{ task1Done ? '1' : '0' }}/1</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div class="flex items-center gap-2">
                <div
                  class="flex-shrink-0 rounded-full"
                  :style="{
                    width: '8px',
                    height: '8px',
                    background: r1Completion.task1Route ? '#28C76F' : 'transparent',
                    border: '2px solid ' + (r1Completion.task1Route ? '#28C76F' : '#6b7280'),
                  }"
                ></div>
                <code class="text-base" :class="r1Completion.task1Route ? 'text-success' : ''"
                  >ip route 10.0.41.10 255.255.255.255 10.0.12.2</code
                >
              </div>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (task2Done ? '#28C76F' : '#3a3f51') }">
            <div
              class="flex items-center gap-2 px-3 py-2"
              :style="{ background: task2Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }"
            >
              <span
                class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white"
                :style="{ width: '20px', height: '20px', fontSize: '10px', background: task2Done ? '#28C76F' : '#4a5568' }"
                >2</span
              >
              <span class="font-semibold text-sm flex-1">R1 Backup Floating Route via R3 (AD 254)</span>
              <span class="text-xs font-medium" :class="task2Done ? 'text-success' : 'text-grey'">{{ task2Done ? '1' : '0' }}/1</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div class="flex items-center gap-2">
                <div
                  class="flex-shrink-0 rounded-full"
                  :style="{
                    width: '8px',
                    height: '8px',
                    background: r1Completion.task2FloatingRoute ? '#28C76F' : 'transparent',
                    border: '2px solid ' + (r1Completion.task2FloatingRoute ? '#28C76F' : '#6b7280'),
                  }"
                ></div>
                <code class="text-base" :class="r1Completion.task2FloatingRoute ? 'text-success' : ''"
                  >ip route 10.0.41.10 255.255.255.255 10.0.13.3 254</code
                >
              </div>
            </div>
          </div>

          <!-- Task 3 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (task3Done ? '#28C76F' : '#3a3f51') }">
            <div
              class="flex items-center gap-2 px-3 py-2"
              :style="{ background: task3Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }"
            >
              <span
                class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white"
                :style="{ width: '20px', height: '20px', fontSize: '10px', background: task3Done ? '#28C76F' : '#4a5568' }"
                >3</span
              >
              <span class="font-semibold text-sm flex-1">Default Routes to Internet</span>
              <span class="text-xs font-medium" :class="task3Done ? 'text-success' : 'text-grey'"
                >{{ [r1Completion.task3DefaultRoute, r3Completion.task3DefaultRoute].filter(Boolean).length }}/2</span
              >
            </div>
            <div class="px-3 py-2">
              <div v-for="rKey in ['r1', 'r3']" :key="rKey" class="mb-2">
                <span
                  class="inline-block text-xs font-semibold px-2 py-px rounded mb-1"
                  style="background: rgba(255, 255, 255, 0.07); letter-spacing: 0.05em"
                  >{{ rKey.toUpperCase() }}</span
                >
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div
                      class="flex-shrink-0 rounded-full"
                      :style="{
                        width: '8px',
                        height: '8px',
                        background: (rKey === 'r1' ? r1Completion : r3Completion).task3DefaultRoute ? '#28C76F' : 'transparent',
                        border: '2px solid ' + ((rKey === 'r1' ? r1Completion : r3Completion).task3DefaultRoute ? '#28C76F' : '#6b7280'),
                      }"
                    ></div>
                    <code class="text-base" :class="(rKey === 'r1' ? r1Completion : r3Completion).task3DefaultRoute ? 'text-success' : ''">
                      ip route 0.0.0.0 0.0.0.0 {{ rKey === 'r1' ? '10.0.13.3' : '209.165.201.1' }}
                    </code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{ border: '1px solid ' + (saveDone ? '#28C76F' : '#3a3f51') }">
            <div
              class="flex items-center gap-2 px-3 py-2"
              :style="{ background: saveDone ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }"
            >
              <feather-icon
                :icon="saveDone ? 'CheckCircleIcon' : 'CircleIcon'"
                :svgClasses="saveDone ? 'text-success' : 'text-grey'"
                size="16"
                class="flex-shrink-0"
              />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone ? 'text-success' : 'text-grey'"
                >{{ [r1Completion.saved, r3Completion.saved].filter(Boolean).length }}/2</span
              >
            </div>
            <div class="px-3 py-2">
              <div v-for="rKey in ['r1', 'r3']" :key="rKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background: rgba(255,255,255,0.07); letter-spacing: 0.05em">{{ rKey.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: (rKey==='r1' ? r1 : r3).endDone ? '#28C76F' : 'transparent', border: '2px solid ' + ((rKey==='r1' ? r1 : r3).endDone ? '#28C76F' : '#6b7280') }"></div>
                    <code class="text-base" :class="(rKey==='r1' ? r1 : r3).endDone ? 'text-success' : ''">end</code>
                  </div>
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: (rKey==='r1' ? r1Completion : r3Completion).saved ? '#28C76F' : 'transparent', border: '2px solid ' + ((rKey==='r1' ? r1Completion : r3Completion).saved ? '#28C76F' : '#6b7280') }"></div>
                    <code class="text-base" :class="(rKey==='r1' ? r1Completion : r3Completion).saved ? 'text-success' : ''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <!-- Right: Terminals -->
      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command
            v-show="selectedRouter === 'r1'"
            key="r1"
            id="r1_terminal"
            :commands="r1Commands"
            :prompt="r1Prompt"
            :show-intro="true"
            intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands."
            style="background-color: #111111; border: 1px solid #181d2a; border-radius: 0.5rem; height: 100%"
            title="R1"
          />
          <vue-command
            v-show="selectedRouter === 'r3'"
            key="r3"
            id="r3_terminal"
            :commands="r3Commands"
            :prompt="r3Prompt"
            :show-intro="true"
            intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands."
            style="background-color: #111111; border: 1px solid #181d2a; border-radius: 0.5rem; height: 100%"
            title="R3"
          />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP_TEXT =
  'Commands:<br>' +
  '&nbsp;ip route [dest] [mask] [nexthop] [AD]<br>' +
  '&nbsp;show ip route<br>' +
  '&nbsp;copy running-config startup-config<br>' +
  '&nbsp;end | exit<br>';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/Static_routing_Configuration_Sim.png',
      selectedRouter: 'r1',
      totalScore: 0,

      r1: { mode: 'exec', routes: [], endDone: false },
      r3: { mode: 'exec', routes: [], endDone: false },

      r1Completion: {
        task1Route: false,
        task2FloatingRoute: false,
        task3DefaultRoute: false,
        saved: false,
      },

      r3Completion: {
        task3DefaultRoute: false,
        saved: false,
      },

      r1Commands: {
        help: () => createStdout(HELP_TEXT),
        enable: () => createStdout(''),
        configure: (x) => this.iosConfigure(this.r1, x),
        conf: (x) => this.iosConfigure(this.r1, x),
        exit: () => this.iosExit(this.r1),
        end: () => this.iosEnd(this.r1),
        ip: (x) => this.iosIpRoute('r1', x),
        show: (x) => this.iosShow(this.r1, x),
        copy: (x) => this.iosCopy(this.r1, this.r1Completion, x),
      },

      r3Commands: {
        help: () => createStdout(HELP_TEXT),
        enable: () => createStdout(''),
        configure: (x) => this.iosConfigure(this.r3, x),
        conf: (x) => this.iosConfigure(this.r3, x),
        exit: () => this.iosExit(this.r3),
        end: () => this.iosEnd(this.r3),
        ip: (x) => this.iosIpRoute('r3', x),
        show: (x) => this.iosShow(this.r3, x),
        copy: (x) => this.iosCopy(this.r3, this.r3Completion, x),
      },
    };
  },

  computed: {
    r1Prompt() {
      return this.r1.mode === 'exec' ? 'R1#' : 'R1(config)#';
    },
    r3Prompt() {
      return this.r3.mode === 'exec' ? 'R3#' : 'R3(config)#';
    },
    r3Unlocked() {
      return this.r1Completion.task3DefaultRoute;
    },
    task1Done() {
      return this.r1Completion.task1Route;
    },
    task2Done() {
      return this.r1Completion.task2FloatingRoute;
    },
    task3Done() {
      return this.r1Completion.task3DefaultRoute && this.r3Completion.task3DefaultRoute;
    },
    saveDone() {
      return this.r1Completion.saved && this.r3Completion.saved;
    },
  },

  watch: {
    'r1Completion.task3DefaultRoute'(val) {
      if (val && !this.r3Completion.task3DefaultRoute) this.switchTo('r3');
    },
    'r1Completion.saved'(val) {
      if (val && !this.r3Completion.saved) this.switchTo('r3');
    },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
  },

  methods: {
    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    switchTo(router) {
      this.selectedRouter = router;
      this.$nextTick(() => {
        const el = document.querySelector(`#${router}_terminal input, #${router}_terminal textarea`);
        if (el) el.focus();
      });
    },

    iosConfigure(state, x) {
      if (state.mode !== 'exec') return createStderr('% Invalid input detected');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        state.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(state) {
      if (state.mode === 'config') { state.mode = 'exec'; state.endDone = true; }
      return createStdout('');
    },

    iosEnd(state) {
      if (state.mode !== 'exec') state.endDone = true;
      state.mode = 'exec';
      return createStdout('');
    },

    iosIpRoute(routerKey, x) {
      const state = this[routerKey];
      const completion = this[routerKey + 'Completion'];

      if (state.mode !== 'config') return createStderr('% Invalid input detected');
      if (x._[1] !== 'route') return createStderr('% Invalid input detected');

      const dest = x._[2];
      const mask = x._[3];
      const nexthop = x._[4];
      const ad = x._[5] !== undefined ? parseInt(x._[5]) : null;

      if (!dest || !mask || !nexthop) return createStderr('% Incomplete command');

      // Score matching routes
      let guideMsg = null;

      if (routerKey === 'r1') {
        if (dest === '10.0.41.10' && mask === '255.255.255.255' && nexthop === '10.0.12.2' && !ad) {
          if (!completion.task1Route) {
            completion.task1Route = true;
            this.updateScore();
            guideMsg = 'Primary host route to 10.0.41.10/32 via R2 (10.0.12.2). A /32 host route matches exactly one IP address — the most specific route always wins over less-specific ones. Default AD 1 makes this the preferred path. → Add the floating backup: "ip route 10.0.41.10 255.255.255.255 10.0.13.3 254".';
          }
        } else if (dest === '10.0.41.10' && mask === '255.255.255.255' && nexthop === '10.0.13.3' && ad === 254) {
          if (!completion.task2FloatingRoute) {
            completion.task2FloatingRoute = true;
            this.updateScore();
            guideMsg = 'Floating static route via R3 (10.0.13.3) with AD 254. AD 254 > AD 1 (primary) — this route stays out of the routing table while R2\'s link is active. If R2 fails, the primary route is withdrawn and AD 254 activates automatically with no manual intervention. → Add default route: "ip route 0.0.0.0 0.0.0.0 10.0.13.3".';
          }
        } else if (dest === '0.0.0.0' && mask === '0.0.0.0' && nexthop === '10.0.13.3' && !ad) {
          if (!completion.task3DefaultRoute) {
            completion.task3DefaultRoute = true;
            this.updateScore();
            guideMsg = 'Default route (gateway of last resort) configured on R1 via 10.0.13.3 (R3). 0.0.0.0/0 matches all destinations with no more specific route — all unknown traffic exits toward R3 and onward to the internet. → Switch to R3 and add its default route: "ip route 0.0.0.0 0.0.0.0 209.165.201.1".';
          }
        }
      }

      if (routerKey === 'r3') {
        if (dest === '0.0.0.0' && mask === '0.0.0.0' && nexthop === '209.165.201.1' && !ad) {
          if (!completion.task3DefaultRoute) {
            completion.task3DefaultRoute = true;
            this.updateScore();
            guideMsg = 'Default route configured on R3 via 209.165.201.1 (ISP gateway). R3 now has a path to the internet for all unknown destinations. → Save both routers: "end" then "copy running-config startup-config".';
          }
        }
      }

      // Store route for show ip route output
      state.routes.push({ dest, mask, nexthop, ad });
      return guideMsg ? createStdout(this.guide(guideMsg)) : createStdout('');
    },

    iosShow(state, x) {
      if (x._[1] === 'ip' && x._[2] === 'route') {
        if (state.routes.length === 0) return createStdout('% No routes configured');
        let out = 'Codes: S - static, C - connected<br><br>';
        state.routes.forEach((r) => {
          const adStr = r.ad ? `[${r.ad}/0]` : '[1/0]';
          const dest = r.dest === '0.0.0.0' ? 'S*   0.0.0.0/0' : `S    ${r.dest}/32`;
          out += `${dest} ${adStr} via ${r.nexthop}<br>`;
        });
        return createStdout(out);
      }
      return createStderr('% Invalid input detected');
    },

    iosCopy(state, completion, x) {
      if (state.mode !== 'exec') return createStderr('% Invalid input detected');
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!completion.saved) {
          completion.saved = true;
          this.updateScore();
        }
        const otherSaved = completion === this.r1Completion ? this.r3Completion.saved : this.r1Completion.saved;
        return createStdout('Building configuration...<br>[OK]' +
          this.guide(otherSaved ? '✓ Both routers saved — simulation complete!' : '→ Save the remaining router.'));
      }
      return createStderr('% Invalid input detected');
    },

    updateScore() {
      let score = 0;
      Object.values(this.r1Completion).forEach((v) => {
        if (v) score++;
      });
      Object.values(this.r3Completion).forEach((v) => {
        if (v) score++;
      });
      this.totalScore = score;
      this.$emit('simulation_update_score', score);
      if (score >= 6) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },
  },

  components: { VueCommand },

  props: {
    data: { type: Object, required: true },
  },
};
</script>

<style>
#r1_terminal,
#r3_terminal {
  overflow: hidden !important;
}

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

